<h2>{{league.name}}</h2>
<app-languages-selections></app-languages-selections>
<div class="language">
    <app-languages></app-languages>
</div>
<app-teams-list></app-teams-list>
